import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Trans } from 'react-i18next'
import { Breadcrumb, Image } from 'semantic-ui-react'

import imgHome from '../resources/home.svg'

import {
  cardDefinitionsDe,
  cardDefinitionsEn,
  cardMatchesContext } from '../all_cards'
import MarkupComponent from './MarkupComponent'

class CardsInContext extends Component {

  render () {
    const { context } = this.props
    const allCardDefinitions = [...cardDefinitionsDe, ...cardDefinitionsEn, ...((context.aufschaltung && context.aufschaltung.additional_cards) || [])]

    const crumb1 = {dashboard: <Trans>Überblick</Trans>, profile: <Trans>Profile</Trans>, api: 'APIs', app: 'Apps', contact: <Trans>Kontakt</Trans>, doc: <Trans>Dokumentation</Trans>}[context.navigation.category] || null
    const crumb2 = context.dashboard ? null : (context.navigation.profile || context.navigation.api || context.navigation.app || null)

    // let title = context.navigation.dashboard ? null : context.navigation.profile ? context.navigation.profile : null
    // title = title === 'ALL' ? '' : title
    // <Header as='h2' style={{color: '#444'}}>{title}</Header>

    const cardsInContext = allCardDefinitions.filter(
        card => cardMatchesContext({card, context})
    )


    return (
      <div className={context.navigation.category}>

        <Breadcrumb className='main-breadcrumb'>
          <Breadcrumb.Section as={NavLink} exact to='/'>
            <Image height={16} src={imgHome} style={{marginBottom: '-2px'}} />
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon='right angle' />
          <Breadcrumb.Section >{ crumb1 }</Breadcrumb.Section>
          {crumb2 ? [ <Breadcrumb.Divider icon='right angle' />,
            <Breadcrumb.Section >{ crumb2 }</Breadcrumb.Section> ] : null}
        </Breadcrumb>

        <MarkupComponent context={context} cardsInContext={cardsInContext} />
      </div>
    )
  }
}

export default CardsInContext



// WEBPACK FOOTER //
// ./src/components/CardsInContext.js